import ActionButtons from '@/components/common/ActionButtons';
import Table from '@/components/common/table/Table';
import { useBiCustomer } from '@/context/biCustomerContext/BiCustomerContextProvider';
import React from 'react';
import { FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import CreateBiCustomer from './CreateBiCustomer';
import { useModal } from '@/components/common/modal/ModalContext';

const BiCustomerTable = () => {
  const { openModal, closeModal } = useModal();

  const {
    fetchBiCustomerData,
    deleteCustomer,
    biCustomerData,
    totalElements,
    currentPage,
    setCurrentPage,
    clearBiCustomerData,
    pageSize,
    sortBy,
    setSortBy,
    sortDir,
    setSortDir,
    searchQuery,
  } = useBiCustomer();

  const handleOpenModal = (user) => {
    clearBiCustomerData();
    openModal(
      <CreateBiCustomer closeModal={closeModal} user={user} />,
      'Update Bi Customer',
    );
  };

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field); // Update the sortBy field
    setSortDir(direction); // Update the sort direction
    fetchBiCustomerData(currentPage, pageSize, searchQuery, field, direction); // Fetch sorted data
  };

  const columns = [
    {
      header: 'Customer Code',
      field: 'account',
    },
    {
      header: 'Customer Name',
      field: 'accountName',
    },
    {
      header: 'Transaction Date',
      field: 'createdDate',
    },
    {
      header: 'Rep',
      field: 'rep',
    },
    {
      header: 'Is New Customer',
      field: 'isNewAccount',
    },
    {
      header: 'Industry Sub',
      field: 'industrySub',
    },
    {
      header: 'Bussiness Code',
      field: 'businessCode',
    },
    {
      header: 'Action',
      render: (user) => (
        <ActionButtons
          actions={[
            {
              icon: <FaTrash />,
              onClick: () => deleteCustomer(user.id),
              tooltip: 'Delete Product',
              className: 'text-red-500 pr-6',
            },
            {
              icon: <MdEdit />,
              onClick: () => handleOpenModal(user),
              tooltip: 'Edit Product',
              className: 'text-gray-500 pr-6',
            },
          ]}
        />
      ),
    },
  ];
  return (
    <>
      {biCustomerData.length === 0 ? (
        <div className="text-center">No data found</div>
      ) : (
        <Table
          data={biCustomerData}
          columns={columns}
          totalElements={totalElements}
          pageSize={pageSize}
          currentPage={currentPage}
          onPageChange={(newPage) => setCurrentPage(newPage)}
          onSortChange={handleSortChange} // Pass sorting handler
          sortConfig={{ field: sortBy, direction: sortDir }} // Pass current sorting state
          keyField="id"
        />
      )}
    </>
  );
};

export default BiCustomerTable;
